export default __webpack_public_path__ + "static/media/help-icon.0ef3e030.svg";